import React, { useState, useEffect } from "react";
import { Grid, makeStyles, Button, Box } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { backend } from "../../../api";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  bookTitle: {
    fontSize: "36px",
    fontWeight: "600",
    marginTop: "0px",
  },
  input: {
    padding: 15,
    borderRadius: "2px",
  },
  priceTag: {
    margin: 0,
  },
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
}));

function BookDetail(props) {
  const { currentBook, author } = props;
  const classes = useStyles();

  return (
    <Box>
      {currentBook && author ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={5}>
            <Box style={{ width: "80%", margin: "0 auto" }}>
              <img
                src={currentBook?.book_cover}
                alt=""
                style={{ width: "100%", height: 300, objectFit: "contain" }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={7}>
            <h1 className={classes.bookTitle}>{currentBook?.book_title}</h1>

            <p>{currentBook?.book_story}</p>
            <p>
              Category:
              {currentBook?.book_category
                ? currentBook?.book_category.category_name
                : "Uncategorized"}
            </p>
            <br />
            <h1 className={classes.bookTitle}>About the author</h1>
            <p>{author?.author_biography}</p>
          </Grid>
        </Grid>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={5}>
              <Skeleton
                variant="rect"
                width="60%"
                height={450}
                style={{ margin: "0 auto" }}
                animation
              />
            </Grid>
            <Grid xs={12} sm={6} md={6} lg={7}>
              <Skeleton
                variant="rect"
                width="90%"
                height={100}
                animation="wave"
              />
              <Skeleton
                animation="wave"
                width="90%"
                style={{ marginTop: 40 }}
              />
              <Skeleton animation="wave" width="75%" />
              <Skeleton animation="wave" width="60%" />
              <Skeleton animation="wave" width="45%" />

              <Skeleton
                animation="wave"
                width={200}
                height={40}
                style={{ marginTop: 30 }}
              />
              <Skeleton animation="wave" width={200} height={40} />
              <Skeleton animation="wave" width={200} height={40} />

              <Box display="flex" mt={5}>
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  style={{ marginLeft: 20 }}
                  animation="wave"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}

export default BookDetail;
